import type { EventLog as ApiEventLog, EventLogType as ApiEventLogType } from '../services/api/generated/model';

export enum EventLogLevel {
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
}

export type EventLogType = Omit<ApiEventLogType, 'nameI18n' | 'messageTemplateI18n'> & {
  name: string;
  messageTemplate: string;
  _multilingual_original_name?: string;
  _multilingual_original_messageTemplate?: string;
};

// title/message/level are denormalised at read time from the matching EventLogType;
// `name` satisfies the GenericEntity contract; event logs have no API-side name.
export type EventLog = ApiEventLog & {
  name: string;
  date?: Date;
  title?: string;
  message?: string;
  level?: number;
};
